<!-- VAZIO -->
<div *ngIf="!activitie">
  <div class="container display-sign empty"></div>
</div>
<!-- VAZIO -->

<ng-container *ngIf="activitie">
  <div class="display-body" *ngIf="activitie && !selectedSign">
    <div class="d-flex align-items-center justify-content-between">
      <!-- TIPO TAREFA -->
      <div class="d-flex mx-0 align-items-center" style="width: 21ch">
        <i class="far fa-lg" [ngClass]="ngIconClass"></i>
        <div class="mx-2 name">{{ activitie['task'].taskType | enumText: 'TaskType' }}</div>
      </div>
      <!-- TIPO TAREFA -->

      <!-- BOTÕES -->
      <div class="d-flex">
        <button class="btn btn-primary d-flex justify-content-center align-items-center p-4 mr-4 ml-3"
          (click)="openTaskPage()" style="height: 32px; font-size: 20px">
          Ver Tarefa
        </button>
      </div>
      <!-- BOTÕES -->
    </div>

    <h3>Informações Gerais</h3>

    <div class="box-info">
      <div class="box-column">
        <h4>Data de Execução</h4>
        <div class="box-row">
          <div>
            <i class="far fa-calendar-clock mr-2 text-muted"></i>
            <span class="mr-4">
              {{activitie?.task?.executionDate | date: 'dd/MM/yyyy'}}
            </span>
          </div>
          <div>
            <i class="fa-solid fa-calendar-clock mr-2 text-muted"></i>
            <span class="mr-4">
              {{activitie?.task?.endDate | date: 'dd/MM/yyyy'}}
            </span>
          </div>
        </div>
      </div>
      <div class="box-row">
        <div class="col-6 px-0">
          <h4>Tarefa</h4>
          <span class="multiline-ellipsis" [title]="activitie?.task?.name ?? '-'">{{activitie?.task?.name ??
            '-'}}</span>
        </div>
        <div class="col-6 px-0">
          <h4>Ordem de Serviço</h4>
          <span class="multiline-ellipsis" [title]="activitie?.servideOrderName ?? '-'">{{activitie?.servideOrderName ??
            '-'}}</span>
        </div>
      </div>
      <div class="box-row">
        <div class="col-6 px-0">
          <h4>Responsável</h4>
          <span class="multiline-ellipsis">{{activitie?.task?.team ?
            activitie?.task?.team?.leaderMember?.user?.firstName + ' ' +
            activitie?.task?.team?.leaderMember?.user?.lastName
            : 'Não Vinculado'}}</span>
        </div>
        <div class="col-6 px-0">
          <h4>Veículo</h4>
          <span>{{activitie?.task?.vehicle ? activitie?.task?.vehicle?.licensePlate : 'Não Vinculado'}}</span>
        </div>
      </div>
    </div>

    <h3>Sinalizações Implantadas</h3>
    <div class="d-flex flex-column" style="gap: 24px">
      <ng-container *ngFor="let sign of activitie?.associatedSigns; let i=index">
        <div class="box-info">
          <div class="box-row">
            <img [src]="sign?.signCode | enumSvg: 'Signaling'" style="object-fit: contain; width: 40px; height: 40px" />
            <span>{{sign?.signCode | enumText: 'Signaling'}}</span>
            <div class="btn-group ml-auto" dropdown container="body">
              <button id="button-basic" dropdownToggle type="button" class="btn btn-icon ellipsis-cell"
                aria-controls="dropdown-basic" style="width: 24px !important">
                <i class="fas fa-ellipsis-v fa-lg"></i>
              </button>
              <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-basic" role="menu"
                aria-labelledby="dropdown-basic">
                <li role="menuitem"
                (click)="signDetailRouting(sign, activitie)">
                  <a class="dropdown-item">Ver Sinalização</a>
                </li>
                <li role="menuitem" (click)="selectSignaling(sign)">
                  <a class="dropdown-item">Editar</a>
                </li>
              </ul>
            </div>
          </div>    

          <hr class="my-0">

          <div class="box-row px-0">
            <div class="box-column col-6" style="gap: 16px;">
              <div class="box-column">
                <h4>Data de Implantação</h4>
                <span>{{ sign?.executionDate | date: 'dd/MM/yyyy'}}</span>
              </div>
              <div class="box-column">
                <h4>Localização da Sinalização</h4>
                <span> {{
                  (sign.address?.road ? sign.address?.road + ', ' : '') +
                  (sign.address?.road
                  ? sign.address?.house_number
                  ? sign.address?.house_number + ' - '
                  : 's/ nº - '
                  : '') +
                  (sign.address?.suburb ? sign.address?.suburb + ', ' : '') +
                  (sign.address?.city ? sign.address?.city : '') +
                  (sign.address?.postcode ? ', ' + sign.address?.postcode : '')
                  }}</span>
              </div>
              <div class="box-column">
                <h4>Valor Total</h4>
                <span>{{ sign?.cost?.toFixed(3) ?? 0}}</span>
              </div>
            </div>
            <app-carrousel-sign-image *ngIf="activitie?.type == signTypeEnum.Vertical" class="col p-0"
              style="cursor: pointer;" (click)="signDetailRouting(sign, activitie)"
              [imagesFiles]="[getSignFile(sign?.verticalSignaling?.verticalSignalingFiles)]"></app-carrousel-sign-image>

            <app-carrousel-sign-image *ngIf="activitie?.type == signTypeEnum.Horizontal" class="col p-0"
              style="cursor: pointer;" (click)="signDetailRouting(sign, activitie)"
              [imagesFiles]="[getSignFile(sign?.horizontalSignalingFiles)]"></app-carrousel-sign-image>

            <app-carrousel-sign-image *ngIf="activitie?.type == signTypeEnum.Device" class="col p-0"
              style="cursor: pointer;" (click)="signDetailRouting(sign, activitie)"
              [imagesFiles]="[getSignFile(sign?.deviceSignalingFiles)]"></app-carrousel-sign-image>
          </div>

        </div>
      </ng-container>
      <ng-container *ngIf="!activitie?.associatedSigns?.length">
        <div class="box-info d-flex align-items-center justify-content-center">
          <span>Nenhuma sinalização criada a partir desta atividade</span>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="display-body" *ngIf="selectedSign">
    <!-- Pendência -->
    <div class="d-flex align-items-center justify-content-between">
      <!-- Título e Ícone -->
      <div class="d-flex mx-0 align-items-center" style="width: 21ch">
        <i class="far fa-pen-to-square"></i>
        <div class="mx-2 name">Editar Sinalização</div>
      </div>
    
      <!-- Botões -->
      <div class="d-flex">
        <button class="btn btn-primary d-flex justify-content-center align-items-center p-4 mr-4 ml-3"
          (click)="cancelSignUpdate()" style="height: 32px; font-size: 20px;">
          CANCELAR
        </button>
        <button class="btn btn-primary d-flex justify-content-center align-items-center p-4 mr-4 ml-3"
          (click)="updateSign()" style="height: 32px; font-size: 20px;">
          SALVAR
        </button>
      </div>
    </div>
    
    
    <!-- Pendência -->

    <!-- Info box 1 -->
    <div class="mt-3 info-box">
      <div class="d-flex align-items-center">
        <div class="row m-0 align-items-center position-relative">
          <!-- SVG H&D -->
          <div *ngIf="!selectedSign.complementInformationType"
            [ngClass]="selectedSign.signCode| enumCaption: 'Caption' : 40" style="bottom: 6px;"
            class="position-relative internal-caption mr-3">
            <span>{{selectedSign.internalCaption}}</span>
            <img [src]="selectedSign.signCode| enumSvg: 'Signaling': selectedSign.type"
              style="width: 40px; height: 40px; object-fit: contain;"
              [ngClass]="{'sign-cam-40': selectedSign?.signCode == verticalSignEnum.ViaFiscalizadaPorCameras}">
          </div>
          <!-- SVG H&D -->

          <!-- SVG Vertical -->
          <div
            *ngIf="selectedSign?.type == signTypeEnum.Vertical && selectedSign.complementInformationType"
            class="d-flex justify-content-center mr-3" style="height: 60px; width: 40px;">
            <img *ngIf="selectedSign.complementInformationType == complementInformationTypeEnum.Additional"
              [src]="complementType(selectedSign)| enumSvg: 'ComplementInformation'"
              style="width: 40px; height: 20px; position: absolute; bottom: 8px; object-fit: contain;">
            <img *ngIf="selectedSign.complementInformationType == complementInformationTypeEnum.Incorporated"
              [src]="complementType(selectedSign)| enumSvg: 'ComplementInformation'"
              style="width: 40px; height: 60px; position: absolute; bottom: 8px; object-fit: contain;">
            <div [ngClass]="selectedSign.signCode| enumCaption: 'Caption' : 32"
              class="position-relative internal-caption" style="height: 32px; width: 32px;">
              <span class="position-absolute" style="z-index: 1;">{{selectedSign.internalCaption}}</span>
              <img [src]="selectedSign.signCode| enumSvg: 'Signaling': selectedSign.type"
                style="width: 32px; height: 32px; position: absolute; object-fit: contain;">
            </div>
          </div>
          <!-- SVG Vertical -->

          <!-- Combinada Vertical -->
          <div *ngIf="selectedSign?.combined" class="mb-3 row mx-3 m-0 align-items-center pr-2"
            style="background-color: var(--snow-dark); border-radius: 8px;">
            <i class="fas fa-link m-2 icon-sign-link"></i>
            <img *ngFor="let item of selectedSign?.combinedSign; let i = index" [src]="item.svg"
              [ngClass]="{'mr-2': i==0}" style="width: 24px; height: 24px; cursor: pointer"
              (click)="selectSignaling(selectedSign, item)">
          </div>
          <!-- Combinada Vertical -->

        </div>

        <!-- Nome -->
        <div class="d-flex flex-column ml-3" style="max-width: 280px;">
          <h4 style="color:var(--gray-base)">Nome da Sinalização</h4>
          <span>{{ selectedSign?.signCode | enumText: 'Signaling' }}</span>
        </div>
        <!-- Nome -->
      </div>

      <hr class="m-0" style="width: 100%; height: 1px">

      <div class="d-flex flex-column" style="gap: 16px">
        <!-- Cadastro e Responsável -->
        <div class="d-flex">
          <div class="d-flex flex-column col-6 p-0">
            <h4 style="color:var(--gray-base)">Data de Cadastramento</h4>
            <span>{{ selectedSign?.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div class="d-flex flex-column col-6 p-0">
            <h4 class="text-muted">Responsável</h4>
            <span>
              {{ getResponsibleMemberName(selectedSign?.responsibleMemberId, workspaceMembers) }}
            </span>            
          </div>
        </div>
        <!-- Cadastro e Responsável -->

        <!-- Vículos -->
        <div class="d-flex">
          <div class="d-flex flex-column col-6 p-0">
            <h4 style="color:var(--gray-base)">Vínculo</h4>
            <span>
              {{ selectedContract ?
              selectedContract?.name :
              'Sem vínculo contratual' }}
            </span>
          </div>
          <div class="d-flex flex-column col-6 p-0">
            <h4 style="color:var(--gray-base)">Vínculo Secundário</h4>
            <span>
              {{ selectedProject?.name ?
              selectedProject?.name :
              'Sem vínculo projetual'}}
            </span>
          </div>
        </div>
        <!-- Vículos -->

        <!-- Custo -->
        <div class="invested-amount">
          <span> {{selectedSign?.type == signTypeEnum.Vertical ? 'Valor da Placa' : 'Valor Investido'}}
          </span>
          <span class="money-text">{{ selectedSign?.cost | currency:'BRL':'R$' }}</span>
        </div>

        <div class="invested-amount" *ngIf="selectedSign?.type == signTypeEnum.Vertical">
          <span> Valor do Suporte </span>
          <span class="money-text">{{ selectedSign?.supportCost | currency:'BRL':'R$' }}</span>
        </div>

        <div class="invested-amount" *ngIf="selectedSign?.type == signTypeEnum.Vertical && shouldDisplayAuxiliarGroup()">
          <span> Valor do Item Auxliliar </span>
          <span class="money-text">{{ selectedSign?.auxiliarItemsCost | currency:'BRL':'R$' }}</span>
        </div>
        <!-- Custo -->
      </div>

    </div>
    <!-- Info box 1 -->

    <!-- Info box 2 -->
    <div class="mt-4 info-box">
      <div class="row" style="gap:16px 0px">

        <!-- Suporte sem Estoque -->
        <ng-container *ngIf="!storage.length && selectedSign.type == signTypeEnum.Vertical">
          <div class="d-flex flex-column col-12">
            <h4 class="mb-1" style="color: var(--gray-base);">
              Suporte
            </h4>
            <div class="row">
              <div class="col-2 pr-0">
                <label for="supportQuantity">Quantidade</label>
                <input class="form-control" name="supportQuantity" type="number"
                  (change)="onChangeSupportQuantity()" [(ngModel)]="selectedSign.verticalSignaling.supportQuantity"
                  [disabled]="selectedSign.verticalSignaling.existingSupport">
              </div>
              <div class="col-10">
                <!-- Com Contrato -->
                <ng-container *ngIf="selectedContract?.id">
                  <label>Item para Suporte</label>
                  <select class="form-control" (change)="onChangeSupportItem($event.target.value)"
                    [(ngModel)]="selectedSign.verticalSignaling.contractSupportItemId"
                    [ngClass]="{ 'select-readonly': selectedSign.verticalSignaling.existingSupport}"
                    [disabled]="selectedSign.verticalSignaling.existingSupport">
                    <option value="" hidden>Selecione o item</option>
                    <option [value]="item.id" *ngFor="let item of roadSignSupportItems">
                      {{item.code ? item.code + ' - ' : '' }}{{ item.name }}
                    </option>
                  </select>
                </ng-container>
                <!-- Com Contrato -->

                <!-- Sem Contrato -->
                <ng-container *ngIf="!selectedContract?.id">
                  <label>Item para Suporte</label>
                  <select class="form-control" [(ngModel)]="selectedSign.verticalSignaling.supportMaterialType"
                    [ngClass]="{ 'select-readonly': selectedSign.verticalSignaling.existingSupport }"
                    [disabled]="selectedSign.verticalSignaling.existingSupport"
                  >
                    <option value="" hidden>Selecione o item</option>
                    <option [value]="item" *ngFor="let item of supportMaterials">
                      {{ item | enumText: 'RoadSignSupport' }}
                    </option>
                  </select>
                </ng-container>
                <!-- Sem Contrato -->
              </div>
            </div>
          </div>

          <!-- Suporte -->
          <div class="col-12">
            <div class="row">
              <!-- Suporte existente -->
              <div class="d-flex col-6">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox" id="checkBoxSupport"
                    name="checkBoxSupport"
                    [(ngModel)]="selectedSign.verticalSignaling.existingSupport"
                    class="custom-control-input cursor-pointer"
                    style="z-index: 10"
                    [(checked)]="selectedSign.verticalSignaling.existingSupport"
                  />
                  <label class="custom-control-label cursor-pointer" for="checkBoxSupport">Suporte
                    Existente</label>
                </div>
              </div>
              <!-- Suporte existente -->

              <!-- Tipo de suporte -->
              <div class="d-flex flex-column col-6" *ngIf="selectedSign?.contract?.id">
                <h4 style="color: var(--gray-base)">Tipo de Suporte</h4>
                <p>
                  {{
                  selectedSign?.contractSupportItemId
                  ? (selectedSign.contractSupportItem.supportMaterial | enumText: 'RoadSignSupport')
                  : '-'
                  }}
                </p>
              </div>
              <!-- Tipo de suporte -->
            </div>
            <!-- Suporte -->
          </div>
        </ng-container>
        <!-- Suporte sem Estoque -->

        <!-- Suporte com Estoque -->
        <ng-container *ngIf="storage.length && selectedSign.type == signTypeEnum.Vertical">
          <div class="d-flex flex-column col-12" *ngIf="!selectedSign?.contract?.id">
            <div>
              <h4 class="mb-1" style="color: var(--gray-base);">
                Suporte
              </h4>
              <div class="col custom-control custom-radio mb-2">
                <input type="radio" name="supportRadio"
                  (change)="setSupportRadioBtnState('contract'); selectedSign.existingSupport = false"
                  id="supportRadio1" class="custom-control-input cursor-pointer" style="z-index: 10"
                  [checked]="supportRadioState.contract" />
                <label class="custom-control-label pl-2" for="supportRadio1">Suporte do Contrato</label>
              </div>
              <ng-container *ngIf="supportRadioState.contract">
                <label>Item do Suporte do Contrato*</label>
                <select class="form-control mb-2" (change)="onChangeSupportItem($event.target.value)"
                  [(ngModel)]="selectedSign.contractSupportItemId"
                  [ngClass]="{ 'select-readonly': selectedSign.existingSupport }">
                  <option value="" hidden>Selecione o item</option>
                  <option [value]="item.id" *ngFor="let item of roadSignSupportItems">
                    {{ item.name }}
                  </option>
                </select>
              </ng-container>
              <div class="col custom-control custom-radio mb-2">
                <input type="radio" name="supportRadio" [checked]="supportRadioState.stock"
                  (change)="setSupportRadioBtnState('stock'); selectedSign.existingSupport = false"
                  id="supportRadio2" class="custom-control-input cursor-pointer" style="z-index: 10" />
                <label class="custom-control-label pl-2" for="supportRadio2">Suporte do Estoque</label>
              </div>
              <ng-container *ngIf="supportRadioState.stock">
                <label>Item do Suporte do Estoque*</label>
                <select class="form-control mb-2" (change)="
                        onChangeSupportItem($event.target.value.split(',')[0], true, $event.target.value.split(',')[1])
                      " [ngClass]="{ 'select-readonly': selectedSign.existingSupport }">
                  <option value="" hidden>Selecione o item</option>
                  <option [value]="[item.contractVerticalItemId, item.id]"
                    *ngFor="let item of roadSignSupportItems">
                    {{ item.contractVerticalItem?.name }} - {{ item.quantity - item.quantityRegistered }}
                    disponíveis
                  </option>
                </select>
              </ng-container>
              <div class="col custom-control custom-radio mb-2">
                <input type="radio" name="supportRadio" [checked]="supportRadioState.existing"
                  (change)="setSupportRadioBtnState('existing')" id="supportRadio3"
                  class="custom-control-input cursor-pointer" style="z-index: 10" />
                <label class="custom-control-label pl-2" for="supportRadio3">Suporte Existente</label>
              </div>
            </div>
          </div>

          <div class="d-flex flex-column col-12" *ngIf="!selectedSign?.contract?.id">
            <label>Item para Suporte</label>
            <select class="form-control" [(ngModel)]="selectedSign.supportMaterialType"
              [ngClass]="{ 'select-readonly': selectedSign.existingSupport }">
              <option value="" hidden>Selecione o item</option>
              <option [value]="item" *ngFor="let item of supportMaterials">
                {{ item | enumText: 'RoadSignSupport' }}
              </option>
            </select>
          </div>

          <div class="d-flex flex-row col-12" *ngIf="!selectedSign?.contract?.id">
            <div class="custom-control custom-checkbox col-6"
              *ngIf="selectedSign.type == signTypeEnum.Vertical">
              <input type="checkbox" id="checkBoxSupport" name="checkBoxSupport"
                [(ngModel)]="selectedSign.existingSupport" class="custom-control-input cursor-pointer"
                style="z-index: 10" [checked]="selectedSign.existingSupport" />
              <label class="custom-control-label cursor-pointer" for="checkBoxSupport">Suporte
                Existente</label>
            </div>

            <div class="d-flex flex-column col-6">
              <h4 style="color: var(--gray-base)">{{ 'Tipo de Suporte' }}</h4>
              <p>
                {{
                selectedSign?.contractSupportItemId
                ? (selectedSign.contractSupportItem.supportMaterial | enumText: 'RoadSignSupport')
                : '-'
                }}
              </p>
            </div>
          </div>
        </ng-container>
        <!-- Suporte com Estoque -->

        <!-- Tipo de sinalização -->
        <h4 class="col-12" style="color: var(--gray-base);">
          {{
          selectedSign.type == signTypeEnum.Vertical
          ? 'Placa'
          : selectedSign.type == signTypeEnum.Horizontal
          ? 'Marcação'
          : 'Dispositivo'
          }}
        </h4>
        <!-- Tipo de sinalização -->

        <!-- Dimensões da sinalização -->
        <div class="d-flex col-9">
          <app-dimension-information style="margin-top: -16px" class="w-100" [signType]="selectedSign.type"
            [dimensionInformationState]="{
              dimensionType: selectedSign?.dimensionType,
              dimension: selectedSign?.dimension ?? 0,
              dimensionX: selectedSign?.dimensionX ?? 0,
              dimensionY: selectedSign?.dimensionY ?? 0,
              diameter: selectedSign?.diameter,
              sideLength: selectedSign?.sideLength,
              units: selectedSign.type != signTypeEnum.Vertical ? selectedSign?.units : 0,
              quantity: selectedSign.type != signTypeEnum.Vertical ? selectedSign?.quantity : 0,
              dash: selectedSign.dash ?? 0,
              spacing: selectedSign.spacing ?? 0
            }" [indexTraffic]="indexSign" [displayDirection]="'row'" [idSign]="selectedSign?.id"
            [signCode]="selectedSign?.signCode" [verticalType]="
              selectedSign.type == signTypeEnum.Vertical ? selectedSign?.verticalType : ''
            " [stockItemId]="
              selectedSign.type == signTypeEnum.Vertical
              ? selectedSign.stockedTrafficSignId
              : selectedSign.stockedDeviceSignalingId || null
            " [projectSignalingItemId]="
              selectedSign.type == signTypeEnum.Vertical
              ? selectedSign.projectSignalingItemId
              : selectedSign.projectSignalingItemId
            " (dimensionInformationEmmitter)="handleDimensionInformation($event)">
          </app-dimension-information>
        </div>
        <!-- Dimensões da sinalização -->

        <!-- Item do contrato -->
        <div class="row w-100 px-3" *ngIf="selectedSign?.contract?.id">
          <div class="col-12">
            <label>{{ selectedSign?.project?.id ? 'Item do Projeto*' : 'Item do Contrato*' }}</label>
            <select class="form-control" (change)="onChangeItemContract($event)"
              [(ngModel)]="selectedSign.contractSignItemId" [ngClass]="{ 'select-readonly': roadLocked }"
              [disabled]="selectedSign.projectId">
              <option value="" hidden>Selecione o item</option>
              <option *ngFor="let roadItem of contractRoadItems" [value]="roadItem?.id"
                [hidden]="selectedSign.type == signTypeEnum.Device && roadItem.signaling != selectedSign?.signCode">
                {{roadItem.code ? roadItem.code + ' - ' : '' }}{{ roadItem.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Garantia -->
        <div class="row w-100 px-3">
          <div class="col-12">
            <h4 class="mb-1">Garantia*</h4>
            <div style="position: relative; width: 100%">
              <input type="text" placeholder="Selecione a data" class="form-control" autocomplete="off"
                #dp="bsDatepicker" bsDatepicker [bsConfig]="{
                isAnimated: true,
                containerClass: 'theme-dark-blue',
                dateInputFormat: 'DD-MM-YYYY',
                showWeekNumbers: false
              }" [(ngModel)]="selectedSign.warranty" />
              <i class="fa-solid fa-calendar position-absolute" (click)="dp.show()"
                style="right: 4%; top: 30%; cursor: text">
              </i>
            </div>
          </div>
        </div>
        <!-- Garantia -->

        <div class="row w-100 px-3" *ngIf="selectedSign?.contract?.id">
          <div [ngClass]="selectedSign.type == signTypeEnum.Vertical ? 'col-6' : 'col-12'">
            <h4 style="color: var(--gray-base)">
              {{
              selectedSign.type == signTypeEnum.Device
              ? 'Dispositivo Aplicado'
              : selectedSign.type == signTypeEnum.Horizontal
              ? 'Material Aplicado'
              : 'Substrato da Placa'
              }}
            </h4>
            <p>{{ roadItemText(true) }}</p>
          </div>
          <div class="col-6" *ngIf="selectedSign.type == signTypeEnum.Vertical">
            <h4 style="color: var(--gray-base)">Tipo da Película</h4>
            <p>{{ roadItemText(false) }}</p>
          </div>
        </div>
        <!-- Item do contrato -->

        <!-- Material da Sinalização Sem Contrato -->
        <ng-container *ngIf="!selectedSign?.contract?.id">
          <!-- Vertical -->
          <ng-container *ngIf="selectedSign.type == signTypeEnum.Vertical">
            <div class="col-12">
              <label>Item para Placa</label>
              <select class="form-control" [(ngModel)]="selectedSign.roadSignSubstrateId">
                <option value="" hidden>Selecione o item</option>
                <option *ngFor="let sub of substrateList?.roadSignSubstrates" [value]="sub?.id">
                  {{ sub.name | enumText: 'RoadSignSubstrate' }}
                </option>
              </select>
            </div>

            <div class="col-12">
              <label>Item para Película</label>
              <select class="form-control" [(ngModel)]="selectedSign.roadSignFilmId">
                <option value="" hidden>Selecione o item</option>
                <option *ngFor="let film of filmList?.roadSignFilms" [value]="film?.id">{{ film?.name }}
                </option>
              </select>
            </div>
            <!-- Material da Vertical (sem contrato) -->
          </ng-container>
          <!-- Vertical -->

          <!-- Horizontal -->
          <div class="col-12" *ngIf="selectedSign.type == signTypeEnum.Horizontal">
            <label>Material Aplicado</label>
            <select class="form-control" [(ngModel)]="selectedSign.roadSignMarkingPaintId">
              <option value="" hidden>Selecione o item</option>
              <option *ngFor="let paint of markPaintingList?.roadSignMarkingPaints" [value]="paint?.id">
                {{ paint?.name }}
              </option>
            </select>
          </div>
          <!-- Horizontal -->
        </ng-container>
        <!-- Material da Sinalização Sem Contrato -->

        <!-- Legenda Interna -->
        <div class="col-12" *ngIf="selectedSign.type == signTypeEnum.Vertical && subtitleSign">
          <h4 class="mb-1" style="color: var(--gray-base)">
            Diagramação
          </h4>
          <div class="row">
            <div class="col-12">
              <label>Legenda Interna da Sinalização</label>
              <input type="text" mask="XXX" class="form-control" [(ngModel)]="selectedSign.internalCaption" />
            </div>
          </div>
        </div>
        <!-- Legenda Interna -->
      </div>
    </div>
    <!-- Info box 2 -->

    <h3 class="mt-3" style="color: var(--blue-base); font-weight: 400">Imagens</h3>
    <div class="d-flex flex-column mt-4 info-box">
      <div>
        <div class="col-12 p-0" *ngFor="let item of imageSigns; let i = index" [ngClass]="{ 'mb-4': i == 0 }">
          <h3 class="mb-3" style="color: var(--gray-base); font-weight: 400">
            {{ i ? 'Fotos da Sinalização' : 'Fotos do Local' }}
          </h3>
          <div class="d-flex mt-2" style="overflow: auto">
            <div *ngFor="let file of imageSigns[i].imagesB64List; index as indexImg" class="mr-3">
              <div [ngClass]="{ 'cursor-pointer': editCreateDetail != registerCatalogEnum.Created }"
                class="d-flex justify-content-center align-items-center box-img-list"
                (click)="downloadFileSign(file.url)">
                <div *ngIf="file" class="position-relative img-box">
                  <img [src]="file.url ? file.url : 'data:image/png;base64,' + file" class="list-image-upload" />
                  <div class="size-file">
                    <h4 style="color: white; pointer-events: none">
                      {{
                      file.file
                      ? (file.file.size / (1024 * 1024) | number: '1.2-2')
                      : (imageSigns[i].imagesFileList[indexImg].size / (1024 * 1024) | number: '1.2-2')
                      }}MB
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</ng-container>
